import { Typography } from 'shared/ui'
import { WidgetItem } from 'pages/chatbot/ui/UnifiedAgent/ui/Chat/ui/Widgets'
import { FOLLOW_UP_WINDOW_OPTIONS } from 'pages/chatbot/ui/UnifiedAgent/ui/AutoFollowUpSection/store/autoFollowUpWidgetStore'
import styles from './styles.module.scss'

type IAutoFollowUpStep2WindowProps = {
  focusedIndex: number
  onSelect: (index: number) => void
}

export const AutoFollowUpStep2Window = ({
  focusedIndex,
  onSelect,
}: IAutoFollowUpStep2WindowProps) => (
  <div className={styles.list}>
    {FOLLOW_UP_WINDOW_OPTIONS.map((item, index) => (
      <WidgetItem
        key={item.id}
        isFocused={index === focusedIndex}
        badgeIndex={index}
        onClick={() => onSelect(index)}
      >
        <Typography variant={'body-rg-regular'} ariaLabel={item.label}>
          {item.label}
        </Typography>
      </WidgetItem>
    ))}
  </div>
)
